import GbpxCourseCategorySelect from './course_category_select'
import GbpxTeacherSelect from './teacher_select'

export default {
  install: (Vue) => {
    Vue.component('gbpx-course-category-select', GbpxCourseCategorySelect)
    Vue.component('gbpx-teacher-select', GbpxTeacherSelect)
  }
}